import { MapStore } from './store';
const access = window.access;
const store = new MapStore({ title: window.map_title, roles: window.map_roles, access: window.access, settings: window.map_settings });

export default store;



// WEBPACK FOOTER //
// ./starling/src/store_instance.js